var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "700px",
    height: "700px",
    viewBox: "0 0 700 700",
    style: {
      enableBackground: "new 0 0 700 700"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M319.9,107.8c-63.7,39.2-101.5,94.5-111,167.8c-6.8,52.6,4.8,101.5,33,146.4c21.3,33.9,49.9,60.2,85.5,78.7 c35.3,18.4,72.9,26.5,112.7,25c40-1.5,76.6-13.7,112.2-35.3c-43.3,66.4-149.2,124.4-263.2,91.3c-119.4-34.7-195.2-155.2-173-275.1 C135.3,203,238.6,101.4,319.9,107.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.5,171.4c7.8-21.5,14.4-39.8,23.1-63.9c9,23.8,15.9,42.5,23.7,63.3c19.9,0,39.5,0,65.8,0c-20.7,16.1-36,28-52.7,41 c5.4,19.3,10.9,38.7,17.9,63.5c-20.9-14.1-37.2-25.2-54.5-36.8c-16.9,11.4-33.3,22.5-54.6,36.8c6.8-24,12.2-42.9,18-63.3 c-15.7-12.2-31.3-24.3-52.1-40.5C405.7,171.4,425,171.4,445.5,171.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.2,379.8c5.1-13.2,9.7-25.2,15.9-41.2c6.4,16.1,11.3,28.2,16.4,41.2c13.4,0.7,26.1,1.5,43.5,2.5 c-13.3,10.8-23,18.8-33.7,27.6c3.4,12.9,6.7,25.7,11.3,43.2c-15-9.8-26-17-37.4-24.4c-11.3,7.5-22.1,14.6-37,24.4 c4.3-16.6,7.5-28.7,11.1-42.8c-9.7-8.1-19.9-16.6-33.6-27.9C308.5,381.3,321,380.6,335.2,379.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.3,382.6c5.8,1,11.5,2,19.3,3.4c-5.3,5.7-9.2,9.9-13.7,14.7c0.8,5.8,1.7,12,3,20.7c-7.4-3.9-12.9-6.7-18.6-9.7 c-5.6,2.9-11.2,5.7-18.7,9.5c1.2-8.4,2.2-14.6,3.3-22.3c-4.5-3.1-9.2-6.5-17.6-12.4c10.5-1.8,16.1-2.8,22.9-3.9 c2.5-4.9,5.3-10.6,9.5-18.8C522.9,371.1,526,376.8,529.3,382.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.4,248.3c5.8,1,11.5,2,19.3,3.4c-5.3,5.7-9.2,9.9-13.7,14.7c0.8,5.8,1.7,12,3,20.7c-7.4-3.9-12.9-6.7-18.6-9.7 c-5.6,2.9-11.2,5.7-18.7,9.5c1.2-8.4,2.2-14.6,3.3-22.3c-4.5-3.1-9.2-6.5-17.6-12.4c10.5-1.8,16.1-2.8,22.9-3.9 c2.5-4.9,5.3-10.6,9.5-18.8C311,236.9,314.2,242.5,317.4,248.3z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDark);
export default __webpack_public_path__ + "static/media/dark.6bc4e997c9cc6a4b1baa2348773ab112.svg";
export { ForwardRef as ReactComponent };